export default __webpack_public_path__ + "static/media/close_button.d83f1deb.svg";